import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { useQuery } from '@apollo/client'
import { CircularProgress } from '@mui/material'
import detailsCorrection from 'src/assets/Endorsement_images/detailsCorrection.svg'
import employeeCorrection from 'src/assets/Endorsement_images/employeeCorrection.svg'
import policyCorrection from 'src/assets/Endorsement_images/policyCorrection.svg'
import assetCorrection from 'src/assets/Endorsement_images/assetCorrection.svg'
import assetDetails from 'src/assets/Endorsement_images/assetDetails.svg'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'
import submittedImg from 'src/assets/Endorsement_images/Group_588.svg'
import ApprovedImg from 'src/assets/Endorsement_images/Group_432.svg'
import blueApprovedImg from 'src/assets/Endorsement_images/blueApproved.svg'
import NewinProgressImg from 'src/assets/Endorsement_images/inProgress.svg'
import cancelImg from 'src/assets/Endorsement_images/Group_102.svg'
import endorsementImg from 'src/assets/Endorsement_images/Group_587.svg'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { Endorsement_details } from 'src/services/individualService'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import { sortField, sortOrder } from 'src/utils/constants/Individual'

function Endorsements({ policyId, clientId, isCEO }) {
  const classes = useStyles()

  const {
    loading: endorsementDetailsLoading,
    error: endorsementDetailsError,
    data: endorsementDetails,
  } = useQuery(Endorsement_details(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      sortField: sortField,
      sort: sortOrder,
      policyId: policyId,
      clientId: clientId,
      viewForCEO: isCEO,
    },
  })
  if (endorsementDetailsLoading)
    return (
      <div className={classes.loaderStyles}>
        <CircularProgress />
      </div>
    )
  if (endorsementDetailsError)
    return <GraphQlErrors error={endorsementDetailsError} />

  const endrosmentImages = {
    'Policy Correction': policyCorrection,
    'Employee Addition & Deletion': employeeCorrection,
    'Employee Details Correction': detailsCorrection,
    'Asset Addition & Deletion': assetCorrection,
    'Asset Details Correction': assetDetails,
    'Individual Addition & Deletion': employeeCorrection,
    'Individual Details Correction': detailsCorrection,
  }
  const options = {
    day: 'numeric',
    month: 'short',
    year: '2-digit',
  }
  const options1 = {
    hour: 'numeric',
    minute: '2-digit',
  }

  const dateFormat = (date) => {
    const dateArray = new Date(date)
      ?.toLocaleString('en-IN', options)
      ?.split(' ')
    const FinDate = dateArray.join('-')
    return FinDate
  }

  const timeFormat = (time) => {
    const dateArray1 = new Date(time)
      ?.toLocaleString('en-IN', options1)
      ?.split(' ')
    const FinTime = dateArray1?.join('')
    return FinTime
  }

  const singleRow = (item) => {
    return (
      <div className={classes.singleRowContainer}>
        <div
          className={`${classes.sumInsuredTableText1} ${classes.endorsementTypeSumInsured}`}
        >
          <img
            src={endrosmentImages?.[item?.endorsementType]}
            className={`${classes.callImage} ${classes.endorsementImgStyles}`}
            alt={'endorsementType'}
            width={'35px'}
          />
          <div>
            <p className={classes.endorsementTxt}>{item.endorsementType}</p>
            <p className={classes.endorsementDate}>
              {item?.updatedOn == null
                ? null
                : dateFormat(item?.updatedOn) +
                  ' / ' +
                  timeFormat(item?.updatedOn)}
            </p>
          </div>
        </div>
        <p
          className={`${classes.sumInsuredTableText1} ${classes.sumInsuredStatus}`}
        >
          {(() => {
            if (
              item?.endorsementStatus === INSURANCE_DETAILS?.REQUEST_APPROVED
            ) {
              return (
                <img
                  src={ApprovedImg}
                  className={classes.stateImage}
                  alt={'ApprovedImg'}
                />
              )
            } else if (
              item?.endorsementStatus ===
                INSURANCE_DETAILS?.REQUEST_SUBMITTED ||
              item?.endorsementStatus === INSURANCE_DETAILS?.REQUEST_INITIATED
            ) {
              return (
                <img
                  src={blueApprovedImg}
                  className={classes.stateImage}
                  alt={'blueApprovedImg'}
                />
              )
            } else if (
              item?.endorsementStatus === INSURANCE_DETAILS?.IN_PROGRESS ||
              item?.endorsementStatus ===
                INSURANCE_DETAILS?.ADDITIONAL_INFORMATION_REQUIRED
            ) {
              return (
                <img
                  src={NewinProgressImg}
                  className={classes.stateImage}
                  alt={'inProgressImg'}
                />
              )
            } else if (
              item?.endorsementStatus === INSURANCE_DETAILS?.REQUEST_REJECTED
            ) {
              return (
                <img
                  src={cancelImg}
                  className={classes.stateImage}
                  alt={'cancelImg'}
                />
              )
            }
          })()}
          <p className={classes.endorsementStatusTxt} id='endStatus'>
            {item?.endorsementStatus}
          </p>
        </p>
        <p
          className={`${classes.sumInsuredTableText1} ${classes.agenEndorsementDownload}`}
        >
          {item?.agentEndorsement?.length ? (
            <div className={classes.agentEndorsementSection}>
              <span>
                {' '}
                <img
                  id='agentEndorsementDownload'
                  src={endorsementImg}
                  className={classes.callImage}
                  alt={'endorsementImg'}
                  onClick={() =>
                    handleDocumentDownload(
                      item?.agentEndorsement,
                      item?.agentEndorsementCopy
                    )
                  }
                ></img>{' '}
              </span>
            </div>
          ) : (
            <div className={classes.empty}>{'-'}</div>
          )}
        </p>
        <p
          className={`${classes.sumInsuredTableText1} ${classes.clientEndorsement}`}
        >
          <div className={classes.submittedImgSection}>
            <span className='cursor-pointer'>
              <img
                id='clientEndorsementDownload'
                src={submittedImg}
                className={classes.callImage}
                alt={'submittedImg'}
                onClick={() =>
                  handleDocumentDownload(
                    item?.clientEndorsement,
                    item?.clientEndorsementDoc
                  )
                }
              />
            </span>
          </div>
        </p>
        <br />
      </div>
    )
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  return (
    <div className={classes.endorsementOuterDiv}>
      <div className={classes.endorsementDiv}>
        <p className={`${classes.portfolioTableText} ${classes.typeColumn}`}>
          Type
        </p>

        <p className={`${classes.portfolioTableText} ${classes.statusColumn}`}>
          Status
        </p>

        <p
          className={`${classes.portfolioTableText} ${classes.endorsementColumn}`}
        >
          Endorsement Copy
        </p>

        <p
          className={`${classes.portfolioTableText} ${classes.submitDetailsColumn}`}
        >
          Submitted Details
        </p>
      </div>
      <div className={classes.endorSementDetailsSection}>
        {endorsementDetails?.getEndorsementPage?.content?.length !== 0 &&
          endorsementDetails?.getEndorsementPage?.content?.map((item) => (
            <>{singleRow(item)}</>
          ))}
        {endorsementDetails?.getEndorsementPage?.content?.length === 0 && (
          <p className={classes.subSectionEndorsement} id='noDataText'>
            No Endorsement Requests
          </p>
        )}
      </div>
    </div>
  )
}

export default Endorsements

const useStyles = makeStyles({
  portfolioTableText: {
    fontWeight: '500',
    color: COLORS.GREY,
    // width: "15vw",
    marginBottom: '5px',
    marginTop: '5px',
  },
  submittedImgSection: {
    marginLeft: '50px',
  },
  typeColumn: {
    width: '27vw',
  },
  statusColumn: {
    width: '12vw',
  },
  subSectionEndorsement: {
    marginTop: '5%',
    fontSize: '20px',
  },
  sumInsuredTableText1: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '10vw',
    fontSize: '12px',
    marginBottom: '-1px',
    borderBottom: `0.5px solid ${COLORS.GREY_11}`,
    padding: '5px',
  },
  endorsementColumn: {
    width: '15vw',
  },
  endorSementDetailsSection: {
    fontSize: '12px',
    // padding: "5px 0px 0px 0px",
  },
  submitDetailsColumn: {
    width: '10vw',
  },
  agenEndorsementDownload: {
    width: '11vw',
  },
  clientEndorsement: {
    width: '13vw',
  },
  singleRowContainer: {
    display: 'flex',
  },
  endorsementTxt: {
    margin: 0,
  },
  endorsementImgStyles: {
    padding: '0px 15px',
  },
  endorsementTypeSumInsured: {
    display: 'flex',
    width: '27vw',
  },
  stateImage: {
    width: '20px',
  },
  agentEndorsementSection: {
    marginLeft: '50px',
    cursor: 'pointer',
  },
  endorsementOuterDiv: {
    width: '100%',
    border: `1px solid ${COLORS.BLACK01}`,
    borderRadius: '10px',
    height: '165px',
    overflow: 'auto',
  },
  endorsementDiv: {
    display: 'flex',
    fontSize: '13px',
    borderBottom: `1px solid ${COLORS.BLACK01}`,
    padding: '5px 0px 0px 0px',
    backgroundColor: COLORS.LIGHT_GREY01,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  loaderStyles: {
    margin: 'auto',
  },
  endorsementDate: {
    margin: '0px 0px',
    textAlign: 'initial',
  },
  sumInsuredStatus: {
    width: '11vw',
    display: 'flex',
    alignItems: 'center',
  },
  endorsementStatusTxt: {
    margin: '0px 0px',
    paddingLeft: '5px',
  },
  empty: {
    marginLeft: '50px',
  },
})
